import PullToRefresh from "react-simple-pull-to-refresh";
import { Loader2Icon, ChevronDown } from "lucide-react";

export default function PulledDownWrapper({ onRefresh, children, className = "" }) {

const LoadingComp = () => {
    return (<><Loader2Icon className="animate-spin text-glass-foreground" color="white" /></>)
}
const PullContent = () => {
    return (<><ChevronDown className="text-glass-foreground"/></>)
}
return (
<PullToRefresh onRefresh={onRefresh} resistance={2.5} pullDownThreshold={70}
    refreshingContent={
        <div className="py-6 flex justify-center">
            <LoadingComp />
        </div>
    }
    pullingContent={
        <div className="py-6 flex justify-center">
            <PullContent />
        </div>
    }>
    <div className={`w-full ${className}`} style={{overscrollBehaviorY: "contain"}}>
        {children}
    </div>
</PullToRefresh>
);
}